import { buildApiUrl, createHeaders } from "./apiClient";

const getCurrentUserId = () => {
  const direct =
    localStorage.getItem("userId") || sessionStorage.getItem("userId");
  if (direct && !Number.isNaN(Number(direct))) return Number(direct);
  try {
    const raw =
      localStorage.getItem("userprofile") ||
      sessionStorage.getItem("userprofile");
    if (raw) {
      const u = JSON.parse(raw);
      return u?.id || u?.user_id || u?.userId || null;
    }
  } catch {
    /* ignore */
  }
  return null;
};

export const fetchLeaderInbox = async ({
  entityType,
  teamKey,
  unreadOnly = false,
  limit = 100,
} = {}) => {
  const userId = getCurrentUserId();
  const params = new URLSearchParams();
  if (entityType) params.set("entity_type", entityType);
  if (teamKey) params.set("team_key", teamKey);
  if (unreadOnly) params.set("unread_only", "1");
  params.set("limit", String(limit));
  const res = await fetch(buildApiUrl(`/leader/inbox?${params.toString()}`), {
    method: "GET",
    headers: createHeaders({ userId }),
  });
  if (!res.ok) throw new Error(`Failed to load inbox (${res.status})`);
  return res.json();
};

export const answerAskExpertQuestion = async (questionId, { answer, archive = false }) => {
  const userId = getCurrentUserId();
  const res = await fetch(
    buildApiUrl(`/ask-expert/questions/${questionId}/answer`),
    {
      method: "POST",
      headers: createHeaders({ userId }),
      body: JSON.stringify({ answer, archive }),
    },
  );
  if (!res.ok) throw new Error(`Failed to submit answer (${res.status})`);
  return res.json();
};

export const approvePodcastEpisode = async (episodeId, { action = "approve", recommended = false } = {}) => {
  const userId = getCurrentUserId();
  const res = await fetch(
    buildApiUrl(`/podcast/episodes/${episodeId}/approve`),
    {
      method: "POST",
      headers: createHeaders({ userId }),
      body: JSON.stringify({ action, recommended }),
    },
  );
  if (!res.ok) throw new Error(`Failed to ${action} episode (${res.status})`);
  return res.json();
};
